import React, { createContext, useState, useEffect } from "react";

export const ResizingContext = createContext();

const ResizingProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ResizingContext.Provider value={{ isMobile }}>
      {children}
    </ResizingContext.Provider>
  );
};

export default ResizingProvider;
